import React from "react";
import styles from "./DashboardCard.module.scss";

type Props = {
  title: string;
  description: string;
  icon?: string;
  icon2?: string;
  onClick?: () => void;
  className?: string;
  backgroundColor?: "Orange" | "Blue" | "Green" | "Purple" | "Yellow";
};

function DashboardCard({ title, description, icon, icon2, onClick, className, backgroundColor }: Props) {
  const getColorClass = (color?: Props["backgroundColor"]): string => {
    switch (color) {
      case "Orange":
        return styles.dashboardCardOrange;
      case "Blue":
        return styles.dashboardCardBlue;
      case "Green":
        return styles.dashboardCardGreen;
      case "Purple":
        return styles.dashboardCardPurple;
      case "Yellow":
        return styles.dashboardCardYellow;
      default:
        return styles.dashboardCardOrange;
    }
  };
  
  return (
    <div
      className={`${styles.dashboardCard} ${getColorClass(backgroundColor)}`}
      onClick={onClick}
    >
      <div className={styles.dashboardCardIconWrapper}>
        {icon && <img src={icon} alt={title} className={styles.dashboardCardIcon} />}
        {icon2 && <img src={icon2} alt={title} className={styles.dashboardCardIcon} />}
      </div>
      <div className={styles.dashboardCardContent}>
        <h3 className={styles.dashboardCardTitle}>{title.split("\n").map((word, index) => <span key={index}>{word}<br /></span>)}</h3>
        <p className={styles.dashboardCardDescription}>{description}</p>
      </div>
    </div>
  );
}

export default DashboardCard;
